import { ContentCard } from "@msuite/ui/content-card";
import { DataGrid } from "@msuite/ui/data-grid";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import React from "react";
import type { PartnerPanelBaseProps } from "../types";
import { PartnerNumericAgreementsRow } from "./partner-numeric-agreements-row";

export function PartnerNumericAgreements({ partnershipId, orgId }: PartnerPanelBaseProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<React.Fragment>
			<ContentCard
				title={t("general.general")}
				icon={icon("FileCheck")}
			>
				<DataGrid>
					<PartnerNumericAgreementsRow
						partnershipId={partnershipId}
						orgId={orgId}
						type="hourly-rate"
					/>
				</DataGrid>
			</ContentCard>
			<ContentCard
				title={t("partners.payment_target")}
				icon={icon("Percent")}
			>
				<DataGrid>
					<PartnerNumericAgreementsRow
						partnershipId={partnershipId}
						orgId={orgId}
						type="payment-target"
					/>
					<PartnerNumericAgreementsRow
						partnershipId={partnershipId}
						orgId={orgId}
						type="early-payment-discount"
					/>
					<PartnerNumericAgreementsRow
						partnershipId={partnershipId}
						orgId={orgId}
						type="early-payment-discount-payment-target"
					/>
				</DataGrid>
			</ContentCard>
		</React.Fragment>
	);
}
